import React from "react";
import "./Header.css";
import logo from "../../Asset/main logo.png";
import heart from "../../Asset/icon/heart.png";
import giftNotification from "../../Asset/icon/giftNotification.png";
import cart from "../../Asset/icon/cart.png";
import { Link, useNavigate } from "react-router-dom";
import { useSelector,useDispatch } from "react-redux";
import { logout } from "../redux/actions/userActions";


const Header = () => {
  const navigate = useNavigate();
  const userLogin=useSelector(state=>state.userLogin)
  const { userInfo}=userLogin;
  const dispatch=useDispatch()
  
  /* function logOut() {
    localStorage.clear();
    navigate("/signup");
  } */
  const logOut=()=>{
    dispatch(logout())
  }

  return (
    <div className="">
      <nav className="navbar navbar-expand-lg  p-0 nav-bg-dark  nav-desktop ">
        <div className="container-fluid p-0">
          <a className="navbar-brand ms-5" href="/#">
            <img src={logo} alt="logo" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a
                  className="nav-link active cl-pm"
                  aria-current="page"
                  href="/#"
                >
                  Paintings
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#">
                  Photography
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#">
                  Drawings
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#">
                  Sculpture
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#">
                  Prints
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#">
                  Features
                </a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/allblog">
                  Blog
                </Link>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/#">
                  Art Advisory
                </a>
              </li>
            </ul>
            <div className="text-white">
              <ul className="navbar-nav mx-auto mb-2 me-3 mb-lg-0">
                <li className="nav-item">
                  <a className="nav-link active " aria-current="page" href="/#">
                    <img src={giftNotification} alt="" />
                    {/* <img src={gift} alt="" /> */}
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link active " aria-current="page" href="/#">
                    <img src={heart} alt="" />
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link active " aria-current="page" href="/#">
                    <img src={cart} alt="" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="navBtn">
             {userInfo?
              <>
              
              <Link to="/myprofile" className="pe-3">
               My Profile
              </Link>
              <Link to="/login" className="borderLeft ps-3" onClick={logOut}>
                Logout
              </Link>
              </>
              :
              <>
                <Link to="/login" className="pe-3">
                  Login
                </Link>
                <Link to="/signup" className="borderLeft ps-3">
                  Register
                </Link>
                </>
                }
              
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
